import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'keys',
})
export class KeysPipe implements PipeTransform {
  transform(value: any): string[] {
    return Object.keys(value);
  }
}
